module.exports = __webpack_public_path__ + "img/logo-header.24682cc1.svg";